import classnames from 'classnames'
import { Circle, withPlusUserListenerConsumer } from 'components'
import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'
import { _route } from 'routes/config'
import { setPlusUser, updatePlusUser } from 'services/plusUsers'
import * as PatientActions from 'store/patients/actions'
import * as PlusUserActions from 'store/plusUsers/actions'
import * as UserActions from 'store/user/actions'
import { FAQ } from './FAQ'
import { PlusComponent } from './PlusComponent'
import { SocialProof } from './SocialProof'
import styles from './style.module.scss'

interface IReduxStateProps {
  patientDetail: any
  user: any
  plusUser: any
}
interface IReduxDispatchProps {
  PlusUserLib: any
  UserLib: any
  PatientsLib: any
}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}
interface IProps extends IReduxProps, RouteComponentProps<{}> {}

export const Payment: React.FC<IProps> = ({
  patientDetail,
  history,
  user,
  PlusUserLib,
  UserLib,
  PatientsLib,
  plusUser
}) => {
  const parentId = user?.auth ? user.auth.uid : '1'
  const parentName = user?.data ? user.data.full_name : '1'
  const parentEmail = user?.data ? user.data.email : '1'

  const getFontSize = (): string =>
    window.innerWidth > 1080
      ? '16px'
      : window.innerWidth > 926
      ? '32px'
      : window.innerWidth > 768
      ? '28px'
      : window.innerWidth > 575
      ? '24px'
      : window.innerWidth > 480
      ? '22px'
      : '16px'

  const [fontSize, setFontSize] = React.useState(getFontSize())

  if (parentId === '1' || parentName === '1' || parentEmail === '1') {
    console.error({ parentId, parentName, parentEmail })
  }

  const updateFontSize = () => {
    setFontSize(getFontSize())
  }

  const getIsMobile = (): boolean =>
    window.innerWidth < 1080 || window.innerWidth < window.innerHeight

  const [isMobile, setIsMobile] = React.useState(getIsMobile())

  const updateIsMobile = () => {
    setIsMobile(getIsMobile())
  }

  React.useEffect(() => {
    // screens and modals should always open at their topmost scroll position
    scrollTo({ top: 0 })

    updatePlusUser(user.auth.uid, PlusUserLib)
    window.addEventListener('resize', updateFontSize)
    window.addEventListener('resize', updateIsMobile)
  }, [])

  React.useEffect(
    () => () => {
      window.removeEventListener('resize', updateFontSize)
      window.removeEventListener('resize', updateIsMobile)
    },
    []
  )

  const onClose = () => {
    window.removeEventListener('resize', updateFontSize)
    const { location } = history
    if (location.state && get(location.state, 'page', null) === 'addChild') {
      const patientId = patientDetail?.patientId
      history.push(_route.abilities(patientId))
    } else if (location.state && get(location.state, 'canGoBack', false)) {
      history.goBack()
    } else {
      history.push(_route.child.list)
    }
  }

  const upgradeUserListener = () => {
    setPlusUser(parentId, PlusUserLib, true)
  }

  return !plusUser.loaded ? (
    <div className={styles.loader}>
      <Circle />
    </div>
  ) : (
    <div className={styles.wrap}>
      <div className={styles.wrap__container}>
        <PlusComponent
          parentId={parentId}
          parentName={parentName}
          parentEmail={parentEmail}
          upgradeUser={upgradeUserListener}
          history={history}
          fontSize={fontSize}
          user={user}
          UserLib={UserLib}
          PatientsLib={PatientsLib}
          PlusUserLib={PlusUserLib}
          isMobile={isMobile}
          onClose={onClose}
        />
      </div>
      <div
        className={classnames(
          styles.wrap__container,
          styles['wrap__container_social-proof']
        )}
      >
        <SocialProof />
      </div>
      <div className={styles.wrap__container}>
        <FAQ isMobile={isMobile} />
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    patientDetail: state.patients.currentPatient,
    user: state.user,
    plusUser: state.plus_user
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PlusUserLib: bindActionCreators(PlusUserActions, dispatch),
    UserLib: bindActionCreators(UserActions, dispatch),
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default compose(
  withPlusUserListenerConsumer,
  connect(mapStateToProps, mapDispatchToProps)
)(Payment)



// WEBPACK FOOTER //
// ./src/pages/Payment/index.tsx